<template>
    <calculation-dialog :display="displayDialog" v-on:close="displayDialog = false">
        <h3 class="basicForm__title">Váš soupis materiálu</h3>
        <a :href="downloadUrl" target="_blank" class="button view-primary-light">
            Stáhnout
        </a>
        <a :href="downloadUrl" target="_blank" class="button view-primary-light">
            Vytisknout
        </a>
    </calculation-dialog>
</template>

<script>


    import CalculationDialog from '../../../dialog/Dialog';

    export default {
        name: 'CalculationDownloadDialog',
        components: {
            CalculationDialog
        },
        props: {
            downloadUrl: String,
        },
        data() {
            return {
                displayDialog: true,
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/construction/control/DownloadDialog.vue